'use client';

import { SWRConfig } from 'swr';
import { localCacheMiddleware } from './local-cache-middleware';

/**
 * 为子树启用 predic 本地缓存中间件（见 local-cache-middleware.ts）。
 * predic layout 已整体挂载；对渲染在 layout 之外的内容（如 openDrawer 的
 * 抽屉内容，实际渲染在根布局），需要用它单独包裹，否则拿不到缓存中间件。
 */
export default function SwrLocalCacheProvider({ children }: { children: React.ReactNode }) {
  return <SWRConfig value={{ use: [localCacheMiddleware] }}>{children}</SWRConfig>;
}
